const Loader = ({ size = 'medium', text = '', fullScreen = false }) => {
    const sizeClasses = {
        small: 'w-8 h-8 border-2',
        medium: 'w-16 h-16 border-4',
        large: 'w-24 h-24 border-4'
    };

    const loader = (
        <div className="flex flex-col items-center justify-center gap-4">
            <div
                className={`${sizeClasses[size]} border-primary border-t-transparent rounded-full animate-spin`}
            ></div>
            {text && (
                <p className="text-base text-gray-700 dark:text-gray-300 font-semibold animate-pulse">
                    {text}
                </p>
            )}
            {!text && (
                <p className="text-sm text-gray-600 dark:text-gray-400 font-medium animate-pulse">
                    Loading...
                </p>
            )}
        </div>
    );

    if (fullScreen) {
        return (
            <div className="fixed inset-0 bg-white/90 dark:bg-black/90 backdrop-blur-sm flex items-center justify-center z-50">
                {loader}
            </div>
        );
    }

    return loader;
};

export default Loader;
